const i = (e) => {
  const t = e.indexOf("_");
  return t === -1 ? e : e.slice(0, t);
}, u = (e) => {
  if (e != null && e.season_number) return e.season_number;
  let t;
  for (let s = 0; s < e.title_code.length; s++)
    if (!isNaN(Number.parseInt(e.title_code.charAt(s), 10))) {
      t = s;
      break;
    }
  let n = e.title_code.slice(t);
  return n.length === 3 ? n.substring(0, 1) : n.substring(0, 2);
}, l = (e) => {
  if (e != null && e.season_number) return e.season_number;
  const t = e.series_prefix.indexOf("_");
  return e.series_prefix.slice(t + 2 - e.series_prefix.length);
}, r = (e) => e != null && e.episode_number ? e.episode_number : e.title_code.slice(-4).substring(2), c = (e) => {
  let t = e.program.length;
  for (let n = e.program.length - 1; n >= e.program.length - 4; n--)
    if (e.program.charAt(n) === "S") {
      t = n;
      break;
    }
  return e.program.slice(0, t).trim();
};
export {
  r as determineEpisodeNumber,
  c as determineProgramTitle,
  u as determineSeasonNumber,
  l as determineSeasonNumberFromSeriesPrefix,
  i as determineSeriesPrefix
};
